import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { showImagePreview as show } from '@/components/ImagePreview'

export const useImagePreview = () => {
  const route = useRoute()
  const router = useRouter()

  const onFindSimilar = (image, offerId) => {
    sessionStorage.setItem(`currentMainImage_${offerId}`, image)

    nextTick(() => {
      const url = `/search?offerId=${offerId}&type=similar`
      if (route.fullPath.includes('imageId')) {
        router.replace(url)
      } else {
        router.push(url)
      }
    })
  }

  const showImagePreviewWithSimilar = ({
    images, startPosition, offerId
  }) => {
    show({
      images,
      startPosition,
      options: {
        slots: {
          footer: ({ current, onClose }) => h(
            Button,
            {
              class: 'image-preview-button',
              block: false,
              onClick: () => {
                onFindSimilar(images[current], offerId)
                onClose()
              }
            },
            () => [
              h(Icon, { name: 'icon-image-search-similar', class: 'image-preview-button__icon' }),
              'Find Similar'
            ]
          )
        }
      }
    })
  }

  return {
    showImagePreviewWithSimilar
  }
}
